import { useState, useEffect } from 'react';
import { useConfig } from '@kega/sps-core';

import { t } from '../../../lib/translations';
import { HamburgerIcon, GridIcon } from '../../../components/icons';

import classes from './ViewToggle.module.css';
import classNames from 'classnames';

const ViewToggle = ({ currentView, onViewChange }) => {
    const config = useConfig();
    const { defaultPLPView } = config.get('productlist');

    const [view, setView] = useState(currentView || defaultPLPView);

    useEffect(() => {
        if (currentView) {
            setView(currentView);
        }
    }, [currentView]);

    const handleViewChange = (newView) => {
        setView(newView);
        onViewChange(newView);
    };

    return (
        <div className={classes.root}>
            <div className={classes.toggle_group}>
                <label className={classNames(classes.toggle_option, { [classes.active]: view === 'GRID' })}>
                    <input
                        type="radio"
                        name="view"
                        value="GRID"
                        checked={view === 'GRID'}
                        onChange={() => handleViewChange('GRID')}
                        className={classes.radio_input}
                    />
                    <span className={classes.radio_label}>
                        <GridIcon size={16} className={classes.icon} />
                        {t('productlist.view.grid')}
                    </span>
                </label>
                
                <label className={classNames(classes.toggle_option, { [classes.active]: view === 'LIST' })}>
                    <input
                        type="radio"
                        name="view"
                        value="LIST"
                        checked={view === 'LIST'}
                        onChange={() => handleViewChange('LIST')}
                        className={classes.radio_input}
                    />
                    <span className={classes.radio_label}>
                        <HamburgerIcon size={16} className={classes.icon} />
                        {t('productlist.view.list')}
                    </span>
                </label>
            </div>
        </div>
    );
};

export default ViewToggle;
